(function(){
  'use strict';
  var handle='bettup-ersatzmatratze-boxspringbett-boxspring-1000';
  if(location.pathname.indexOf('/products/'+handle)===-1)return;

  function norm(v){return String(v||'').replace(/\s+/g,' ').trim();}
  function make(tag,cls,html){var e=document.createElement(tag);e.className=cls;e.innerHTML=html;return e;}
  function track(name,detail){window.dataLayer=window.dataLayer||[];window.dataLayer.push(Object.assign({event:name},detail||{}));}
  function shortHardness(v){var m=String(v||'').match(/H(?:a|ä)rtegrad\s*(\d)/i);return m?'H'+m[1]:norm(v);}
  function choice(name,value){
    name=norm(name).replace(/^options\[|\]$/g,'');value=norm(value);
    if(!value||/bitte .*wählen/i.test(value))return '';
    if(/härtegrad|hartegrad/i.test(name))return 'Härte '+shortHardness(value);
    if(/breite/i.test(name))return 'Breite '+value;
    if(/länge|laenge/i.test(name))return 'Länge '+value;
    return name?name+' '+value:value;
  }
  function update(root){
    var text=root.querySelector('[data-bettup-comfort-summary-text]');if(!text)return;
    var values=[];
    root.querySelectorAll('.variant-wrapper select').forEach(function(s){
      var o=s.options[s.selectedIndex];var c=choice(s.dataset.name||s.getAttribute('aria-label')||s.name,o&&(o.textContent||o.value));if(c)values.push(c);
    });
    root.querySelectorAll('.variant-wrapper fieldset').forEach(function(f){
      var r=f.querySelector('input[type="radio"]:checked');if(!r)return;
      var l=r.id?f.querySelector('label[for="'+CSS.escape(r.id)+'"]'):null;var c=choice(f.getAttribute('name'),l?l.textContent:r.value);if(c)values.push(c);
    });
    var h=root.querySelector('[data-bu-height-select]');if(h&&h.value)values.push('Höhe '+h.value);
    text.textContent=values.length?values.join(' · '):'Bitte Größe, Härtegrad und Kernhöhe auswählen.';
    text.closest('.bettup-comfort-summary').classList.toggle('is-complete',Boolean(h&&h.value&&values.length>=4));
  }
  function enhance(root){
    if(root.dataset.bettupComfortFocus)return;root.dataset.bettupComfortFocus='true';
    root.classList.add('bettup-comfort-focus');document.body.classList.add('bettup-comfort-product');
    var info=root.querySelector('.item-info'),title=info&&info.querySelector('.row.type_title'),price=info&&info.querySelector('.row.type_price');
    if(!info||!title||!price)return;

    title.insertBefore(make('span','bettup-comfort-badge','Unsere Empfehlung'),title.firstChild);
    title.appendChild(make('p','bettup-comfort-lead','Unser meistgewählter Kern für punktelastische Unterstützung, ruhiges Liegen und individuell passende Härtegrade.'));

    var proof=make('div','bettup-comfort-proof','<span><strong>66 Nächte</strong> testen</span><span><strong>Kostenlose</strong> Rückgabe</span><span><strong>5 Jahre</strong> Garantie</span>');
    proof.setAttribute('aria-label','Vorteile beim Kauf des Comfort 1000');price.after(proof);
    proof.after(make('div','bettup-comfort-selection-heading','<strong>Deine Ausführung wählen</strong><span>Größe, Härtegrad und anschließend die gemessene Kernhöhe auswählen.</span>'));

    var hard=Array.prototype.find.call(root.querySelectorAll('.variant-wrapper'),function(w){return /härtegrad|hartegrad/i.test(norm(w.textContent));});
    if(hard){
      var msg=encodeURIComponent('Hallo bettUP-Team von Studio1,\n\nich bin beim Härtegrad für den Comfort 1000 unsicher und wünsche eine kurze Einschätzung.');
      hard.appendChild(make('div','bettup-comfort-hardness-help','<span>Die Gewichtsangabe ist eine Orientierung.</span> <a data-bettup-whatsapp-branded="true" aria-label="Härtegrad per WhatsApp mit dem bettUP-Team von Studio1 prüfen lassen" href="https://wa.me/4915251741750?text='+msg+'">Härtegrad kurz prüfen lassen</a>'));
    }

    var form=root.querySelector('form[action*="/cart/add"],form[id^="ProductForm-"]'),buttons=form&&form.querySelector('.buttons');
    if(buttons){
      buttons.before(make('div','bettup-comfort-summary','<div><strong>Deine Auswahl</strong><span data-bettup-comfort-summary-text>Bitte Größe, Härtegrad und Kernhöhe auswählen.</span></div><span class="bettup-comfort-summary__check" aria-hidden="true">✓</span>'));
    }
    update(root);
    root.addEventListener('change',function(e){
      if(!e.target.matches('.variant-wrapper select,.variant-wrapper input,[data-bu-height-select]'))return;
      update(root);track('bettup_comfort_selection_change',{field:e.target.dataset.name||e.target.name||'',value:e.target.value||''});
    });
    root.addEventListener('click',function(e){if(e.target.closest('.bettup-comfort-hardness-help a'))track('bettup_comfort_hardness_help_click');});
  }
  function scan(){document.querySelectorAll('.content.product[data-url*="'+handle+'"]').forEach(enhance);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
  [250,800,1800].forEach(function(d){setTimeout(scan,d);});document.addEventListener('shopify:section:load',scan);
})();
